import React from 'react';
import _ from 'lodash';
import { CSVLink } from "react-csv";

const INSPECTORS = window.wpApiSettings.fiq_inspectors;
const TRAINERS = window.wpApiSettings.fiq_trainers;

const INSPECTORS_headers = [
	{ label: "id", key: "id" },
	{ label: "siteadmin_id", key: "siteadmin_id" },
	{ label: "first_name", key: "first_name" },
	{ label: "last_name", key: "last_name" },
	{ label: "address", key: "address" },
	{ label: "city", key: "city" },
	{ label: "state", key: "state" },
	{ label: "zip", key: "zip" },
	{ label: "phone", key: "phone" },
	{ label: "user_login", key: "user_login" },
	{ label: "user_email", key: "user_email" },
	{ label: "type", key: "type" },
	{ label: "company", key: "company" },

	{ label: "ssf_order_course", key: "ssf_order_course" },
	{ label: "ssf_order_date", key: "ssf_order_date" },
	{ label: "ssf_order_num", key: "ssf_order_num" },
	{ label: "ssf_trainer_id", key: "ssf_trainer_id" },
	{ label: "ssf_cert_num", key: "ssf_cert_num" },
	{ label: "ssf_award_date", key: "ssf_award_date" },
	{ label: "ssf_expiration_date", key: "ssf_expiration_date" },
	{ label: "ssf_cert_status", key: "ssf_cert_status" },
	{ label: "ssf_cert_path", key: "ssf_cert_path" },
	{ label: "ssf_id_path", key: "ssf_id_path" },

	{ label: "rev_order_course", key: "rev_order_course" },
	{ label: "rev_order_date", key: "rev_order_date" },
	{ label: "rev_order_num", key: "rev_order_num" },
	{ label: "rev_trainer_id", key: "rev_trainer_id" },
	{ label: "rev_cert_num", key: "rev_cert_num" },
	{ label: "rev_award_date", key: "rev_award_date" },
	{ label: "rev_expiration_date", key: "rev_expiration_date" },
	{ label: "rev_cert_status", key: "rev_cert_status" },
	{ label: "rev_cert_path", key: "rev_cert_path" },
	{ label: "rev_id_path", key: "rev_id_path" },
];

const TRAINERS_headers = [
	{ label: "id", key: "id", },
	{ label: "company", key: "company", },
	{ label: "address", key: "address", },
	{ label: "city", key: "city", },
	{ label: "state", key: "state", },
	{ label: "zip", key: "zip", },
	{ label: "phone", key: "phone", },
	{ label: "user_email", key: "user_email", },
	{ label: "type", key: "type", },
];

class Inspectors extends React.Component {
	constructor(props) {
		super();
	}

	render() {
		return (
			<div className='filter-list reports'>
				<h4>1. Download a CSV copy of all inspectors? &nbsp;
					<CSVLink data={INSPECTORS} headers={INSPECTORS_headers} filename={"all_inspectors.csv"} className='button button-secondary'>
						Download
					</CSVLink>
				</h4>
				<h4>2. Download a CSV copy of all trainers? &nbsp;
					<CSVLink data={TRAINERS} headers={TRAINERS_headers} filename={"all_trainers.csv"} className='button button-secondary'>
						Download
					</CSVLink>
				</h4>
			</div>
		);
	}
}

export default Inspectors;